import * as React from "react"
import styled from "styled-components"
import CircularProgress from "@mui/material/CircularProgress"
import { MELOGY_WHITE } from "../../style/colors"

const Container = styled.div`
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
`

function CircularProgressBar() {
    return (
        <Container>
            <CircularProgress
                sx={{ color: MELOGY_WHITE }}
                size={16}
                thickness={6}
            />
        </Container>
    )
}

export default CircularProgressBar
